const React = require('react');

const Icon = require('./Icon');

const CopyButton = (props) => {
  const { info = 'Copy to clipboard', data } = props;

  const [copied, setCopied] = React.useState(false);
  React.useEffect(() => {
    if (copied) {
      const timeout = setTimeout(() => setCopied(false), 2000);
      return () => clearTimeout(timeout);
    }
  }, [copied]);

  const copyLink = () => {
    try {
      navigator.clipboard.writeText(data);
      setCopied(true);
    }
    catch(e) {
      console.error('Not able to copy to clipboard', e);
      alert('Not able to copy to clipboard, sorry - try copying with Ctrl-c!');
    }
  }

  return (
    <a onClick={copyLink} className="link" title={info}>
      {copied ? '👍' : <Icon type="copy" />}
    </a>
  );
};

module.exports = CopyButton;